import { render } from "./Alert.vue?vue&type=template&id=06e76e1f&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=06e76e1f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e76e1f"]])

export default __exports__